"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingButton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function LoadingButton(_ref) {
  let {
    children,
    disabled,
    loading = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, rest, {
    disabled: disabled || loading
  }), loading && /*#__PURE__*/_react.default.createElement(StyledCircularProgress, {
    size: 14
  }), children);
}
const StyledCircularProgress = (0, _styledComponents.default)(_CircularProgress.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 5px;\n"])));
LoadingButton.defaultProps = {
  loading: false
};
LoadingButton.propTypes = {
  children: _propTypes.default.node.isRequired,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool
};